import API from '/vercel/path0/theme-default/builtins/API/index.js';
import Badge from '/vercel/path0/theme-default/builtins/Badge/index.js';
import CodeGroup from '/vercel/path0/theme-default/builtins/CodeGroup/index.js';
import Container from '/vercel/path0/theme-default/builtins/Container/index.js';
import Previewer from '/vercel/path0/node_modules/dumi-theme-mobile/dist/builtins/Previewer/index.js';
import SourceCode from '/vercel/path0/theme-default/builtins/SourceCode/index.js';
import Table from '/vercel/path0/theme-default/builtins/Table/index.js';
import Tree from '/vercel/path0/theme-default/builtins/Tree/index.js';
import ThemeCases from '/vercel/path0/.dumi/theme/builtins/ThemeCases/index.tsx';
import WhoAreUsing from '/vercel/path0/.dumi/theme/builtins/WhoAreUsing/index.tsx';
import { DumiDemo } from 'dumi';
import { DumiDemoGrid } from 'dumi';
import { Link } from 'dumi';

import LoadingComponent from '@@/dumi/theme/loading';
import React, { Suspense } from 'react';
import { DumiPage, useTabMeta, useRouteMeta } from 'dumi';

function DumiMarkdownInner() {
  const { texts: $$contentTexts } = useRouteMeta();

  return <><div className="markdown"><h1 id="移动端组件研发"><a aria-hidden="true" tabIndex="-1" href="#移动端组件研发"><span className="icon icon-link" /></a>{"移动端组件研发"}</h1><h2 id="启用方式"><a aria-hidden="true" tabIndex="-1" href="#启用方式"><span className="icon icon-link" /></a>{"启用方式"}</h2><p>{$$contentTexts[0].value}</p><SourceCode lang="bash">{$$contentTexts[1].value}</SourceCode><p>{$$contentTexts[2].value}<code>{$$contentTexts[3].value}</code>{$$contentTexts[4].value}</p><SourceCode lang="ts">{$$contentTexts[5].value}</SourceCode><p>{$$contentTexts[6].value}<Link to="/theme/mobile">{$$contentTexts[7].value}</Link>{$$contentTexts[8].value}</p><h2 id="效果预览"><a aria-hidden="true" tabIndex="-1" href="#效果预览"><span className="icon icon-link" /></a>{"效果预览"}</h2></div><DumiDemo {...{
  "demo": {
    "id": "docs-guide-mobile-library-demo-0"
  },
  "previewerProps": {
    "title": "demo 预览器示例",
    "description": "<p>和默认主题一样可以为 demo 配置介绍文案。</p>\n<p>且相较 dumi 1 新增了 <code>compact</code>（配置为 <code>true</code> 时没有内边距）和 <code>background</code>（修改背景色）配置项的支持。</p>"
  }
}} /></>;
}

// export named function for fastRefresh
// ref: https://github.com/pmmmwh/react-refresh-webpack-plugin/blob/main/docs/TROUBLESHOOTING.md#edits-always-lead-to-full-reload
function DumiMarkdownContent() {
  // wrap suspense for catch async meta data
  return <DumiPage><Suspense fallback={<LoadingComponent />}><DumiMarkdownInner /></Suspense></DumiPage>;
}

export default DumiMarkdownContent;